export default "__VITE_ASSET__Zy7xBlPm__"